import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "mc",
  style: {"margin-top":"10px"}
}
const _hoisted_4 = {
  class: "w100 pad15 with_white_bg",
  style: {"padding-top":"30px"}
}
const _hoisted_5 = { class: "centered" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr mt3",
  style: {}
}, "件名: ", -1)
const _hoisted_7 = {
  key: 1,
  class: "fs13 fw600 orange"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailPreviewSimpleText = _resolveComponent("MailPreviewSimpleText")!
  const _component_MailPreviewCreateRoom = _resolveComponent("MailPreviewCreateRoom")!
  const _component_MailPreviewInquire = _resolveComponent("MailPreviewInquire")!
  const _component_MailPreviewTheDayBefore = _resolveComponent("MailPreviewTheDayBefore")!
  const _component_MailPreviewBeforeDeadline = _resolveComponent("MailPreviewBeforeDeadline")!
  const _component_MailPreviewSharedCalendar = _resolveComponent("MailPreviewSharedCalendar")!
  const _component_MailPreviewFixAppo = _resolveComponent("MailPreviewFixAppo")!
  const _component_MailPreviewFeedback = _resolveComponent("MailPreviewFeedback")!
  const _component_MailPreviewAutoRemind = _resolveComponent("MailPreviewAutoRemind")!
  const _component_MailPreviewCustom = _resolveComponent("MailPreviewCustom")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "dismiss",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissModal && _ctx.dismissModal(...args)))
    }, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
        width: "50",
        height: "50"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.rm.userInfo)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "fs24 fw600 appointmentTitle withEditable pointer posRe",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickTitle && _ctx.clickTitle(...args)))
              }, _toDisplayString(_ctx.getMailSubject()), 1))
            : _createCommentVNode("", true),
          (_ctx.rcm && _ctx.rcm.showSMSField)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" ※ SMS送信では件名は表示されません")
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_9
      ]),
      _hoisted_10,
      _hoisted_11,
      (_ctx.rcm.selectedMailFlow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.rm.user_setting.mail_display_type == `simple` || _ctx.rcm.showSMSField)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_MailPreviewSimpleText, { onAddMessage: _ctx.addMessage }, null, 8, ["onAddMessage"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.rcm.selectedMailFlow.def_type == `create_room`)
                    ? (_openBlock(), _createBlock(_component_MailPreviewCreateRoom, {
                        key: 0,
                        onAddMessage: _ctx.addMessage
                      }, null, 8, ["onAddMessage"]))
                    : (_ctx.rcm.selectedMailFlow.def_type == `inquire_on_public_room`)
                      ? (_openBlock(), _createBlock(_component_MailPreviewInquire, {
                          key: 1,
                          onAddMessage: _ctx.addMessage
                        }, null, 8, ["onAddMessage"]))
                      : (_ctx.rcm.selectedMailFlow.def_type == `the_day_before`)
                        ? (_openBlock(), _createBlock(_component_MailPreviewTheDayBefore, {
                            key: 2,
                            onAddMessage: _ctx.addMessage
                          }, null, 8, ["onAddMessage"]))
                        : (_ctx.rcm.selectedMailFlow.def_type == `one_day_before_deadline`)
                          ? (_openBlock(), _createBlock(_component_MailPreviewBeforeDeadline, {
                              key: 3,
                              onAddMessage: _ctx.addMessage
                            }, null, 8, ["onAddMessage"]))
                          : (_ctx.rcm.selectedMailFlow.def_type == `shared_calendar`)
                            ? (_openBlock(), _createBlock(_component_MailPreviewSharedCalendar, {
                                key: 4,
                                onAddMessage: _ctx.addMessage
                              }, null, 8, ["onAddMessage"]))
                            : ([`fix`, `fixed_appointment`].includes(_ctx.rcm.selectedMailFlow.def_type))
                              ? (_openBlock(), _createBlock(_component_MailPreviewFixAppo, {
                                  key: 5,
                                  onAddMessage: _ctx.addMessage
                                }, null, 8, ["onAddMessage"]))
                              : ([`feedback`].includes(_ctx.rcm.selectedMailFlow.def_type))
                                ? (_openBlock(), _createBlock(_component_MailPreviewFeedback, {
                                    key: 6,
                                    onAddMessage: _ctx.addMessage
                                  }, null, 8, ["onAddMessage"]))
                                : ([`auto_remind`].includes(_ctx.rcm.selectedMailFlow.def_type))
                                  ? (_openBlock(), _createBlock(_component_MailPreviewAutoRemind, {
                                      key: 7,
                                      onAddMessage: _ctx.addMessage
                                    }, null, 8, ["onAddMessage"]))
                                  : ([`custom`].includes(_ctx.rcm.selectedMailFlow.def_type))
                                    ? (_openBlock(), _createBlock(_component_MailPreviewCustom, {
                                        key: 8,
                                        onAddMessage: _ctx.addMessage
                                      }, null, 8, ["onAddMessage"]))
                                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}